<template>
  <div>
    <headerNav :title="rechargeType == 0 ? '大货充值' : '物料充值'" />
    <div class="info mz-main">
      <div class="mz-main-tit-left">
        <van-icon
          class="v-icon"
          :size="34"
          :color="$abctheme.basecolor"
          class-prefix="abc-icon"
          name="huaban1"
        />
        <div>充值金额</div>
      </div>
      <div class="mz-main-tit-ipt">
        <span class="mz-main-tit-icon">￥</span>
        <!-- 后期需要优化只能输入数字键盘!-->
        <input v-model.number="model.money" placeholder="请填写充值金额" />
      </div>
      <!-- <van-form @submit="onSubmit">
          <van-field
            v-model="model.money"
            name="充值金额"
            label="充值金额"
            placeholder="充值金额"
            :rules="[{ required: true, message: '请填写充值金额' }]"
          />
          <van-field v-model="model.remark" name="备注" label="备注" placeholder="备注" />
          <div style="margin:16px;">
            <van-button round block type="info" native-type="submit">提交充值</van-button>
          </div>
        </van-form> -->
    </div>

    <div class="info mz-mark">
      <div>充值备注</div>
      <div>
        <input v-model="model.remark" placeholder="请填写充值备注" />
      </div>
    </div>

    <div class="info mz-proof">
      <div class="mz-proof-upload">
        <div class="mz-proof-upload">
          <van-uploader
            upload-text="上传凭据"
            v-model="fileList"
            :max-count="1"
            :after-read="afterRead"
            accept="image/*"
          >
          </van-uploader>
        </div>
      </div>
    </div>
    <div class="info mz-proof" style="color: #a0a0a0" v-if="rechargeType == 0">
      充值提示：首充金额不低于{{
        abp.userInfo.memberLevelModel.firstRechargeMin
      }}元，补货金额不低于{{ abp.userInfo.memberLevelModel.everyRechargeMin }}元且金额为{{
        abp.userInfo.memberLevelModel.discount
      }}的倍数
      <p>
        温馨提示：如公司有做充值赠送礼品的活动，礼品收货地址为您的默认地址，请确认地址是否准确。
        <span style="color: red"
          >当前礼品收件信息为：{{ defaultaddress.receiverName }}，{{
            defaultaddress.receiverMobile
          }}，{{
            defaultaddress.receiverState +
            defaultaddress.receiverCity +
            defaultaddress.receiverDistrict +
            defaultaddress.receiverAddress
          }}。（如不正确，请到收货地址管理变更默认地址后再提交充值订单）</span
        >
      </p>
    </div>
    <div class="info mz-proof" style="color: #a0a0a0" v-else>
      充值提示：充值金额不低于{{
        abp.userInfo.memberLevelModel.accessoriesEveryRechargeMin
      }}元
    </div>
    <!-- <div class="mz-ls">
        充值流水号
      </div> -->

    <div class="btns">
      <van-button @click="onSubmit" class="setbtns"  :color="$abctheme.basecolor">提交充值</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      rechargeType: 0,
      model: {},
      fileList: [],
      defaultaddress: 0,
    };
  },
  created() {
    this.rechargeType = this.$route.query.rechargeType;
    if (this.rechargeType == 0) {
      this.ajax.post("/api/services/app/PhoneUser/QueryDefaultAddr", 0).then((x) => {
        this.defaultaddress = x.result;
        if (!this.defaultaddress.id) {
          this.$dialog
            .confirm({
              title: "提示",
              message: `您当前未设置默认收货地址,如公司做充值活动,可能会导致您无法收到赠品,点击确定前往设置默认收货地址`,
            })
            .then(() => {
              this.$router.push({ path: "/user/address", query: { state: 1 } });
            })
            .catch(() => {});
        }
      });
    }
  },
  methods: {
    afterRead(file) {
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file); //接口需要传的参数
      if(file instanceof Array)
      {
          //作为数组处理
          file.forEach(x=>
          {
              formData.append('files', x.file,x.file.name);
              x.status = 'uploading';
              x.message= '上传中...';
              
          })
      }
      else
      {
          formData.append("file", file.file);
          file.status = 'uploading';
          file.message = '上传中...';
      }
      this.ajax
        .post("/File/SaveProofPic", formData)
        .then((x) => {
          var imgurl = x.result.data[0];
          this.$toast("图片上传成功");
          this.model.proofPath = imgurl;
          console.log("打印图片路径:" + x);
          if(file instanceof Array)
          {
              file.forEach((y,index)=>
              {
                  y.status = '';
                  y.message = '';
                  y.mpath=this.imglist[index];
              });
          }
          else
          {
              file.status = '';
              file.message = '';
              file.mpath=imgurl;
          }
        })
        .catch(() => {
          this.model.proofPath = '';
          if(file instanceof Array)
          {
              file.forEach((y,index)=>
              {
                  y.status = 'failed';
                  y.message = '上传失败';
                  y.mpath=this.imglist[index];
              });
          }
          else
          {
              file.status = 'failed';
              file.message = '上传失败';
          }
          if (this.model.proofPath) {
            this.fileList = [this.memberInfo.cardHeadPic];
          }
        });
    },
    onSubmit() {
      if (!Number.parseFloat(this.model.money)) {
        this.$toast.fail("请输入正常金额");
        return;
      }
      if (this.model.money <= 0) {
        this.$toast.fail("充值金额必须大于0");
        return;
      }
      // if (!(this.model.proofPath && this.model.proofPath.length>0)) {
      //   this.$toast.fail("凭证不能为空");
      //   return;
      // }
      let url = "/api/services/app/PhoneWallet/RechargeLargeLoans";
      if (this.rechargeType == 1) {
        url = "/api/services/app/PhoneWallet/RechargeAssist";
      }
      this.ajax.post(url, this.model).then(() => {
        this.$toast.success("充值订单提交成功，等待审核中...");
        this.$router.back(-1);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.info {
  position: relative;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 1px 1px 4px #bbb;
  margin: 20px 10px 10px 10px;
  font-size: 12px;
  padding: 25px;
}
.mz-main-tit-left {
  position: relative;
  padding-left: 40px;
  line-height: 40px;
  font-size: 18px;
  color: #a0a0a0;
}
.v-icon {
  position: absolute;
  left: 0;
}
.mz-main-tit-ipt {
  position: relative;
  padding-left: 50px;
  line-height: 50px;
}
.mz-main-tit-icon {
  font-size: 40px;
  position: absolute;
  left: 0;
  top: 0;
}
.mz-main-tit-ipt input {
  border: 0;
  font-size: 25px;
  width: 100%;
}
.mz-mark {
  font-size: 18px;
  color: #a0a0a0;
}
.mz-mark input {
  width: 100%;
  font-size: 25px;
  line-height: 50px;
  border: 0;
}
.mz-ls {
  font-size: 10px;
  margin: 20px 10px 10px 10px;
  padding: 0 0px 0 18px;
}
.btns {
  text-align: center;
}
.btns button {
  border-radius: 7px;
  background-color: #ffe637;
  padding: 0 40px;
}
.van-uploader {
  position: relative;
  display: block;
}
</style>

<style lang="scss" scoped>
.van-uploader__wrapper {
  width: 100%;
  display: block;
}

.van-uploader__upload {
  width: 100%;
}
.van-uploader__preview-image {
  width: 100%;
  height: 80px;
}
</style>
